import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getMaintenanceStatusList,
	addNewMaintenanceStatus,
	updateMaintenanceStatus,
	deleteMaintenanceStatus,
	getMaintenanceStatus,
	getMaintenanceStatusCode
} from '../maintenanceStatus/thunk';

export const initialState = {
	itemMaintenanceStatusList: [],
	itemMaintenanceStatusDetail: null,
	isMaintenanceStatusLoading: false,
	isMaintenanceStatusSuccess: false,


	maintenanceStatusList: [],
	maintenanceStatusListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const MaintenanceStatusSlice = createSlice({
	name: 'MaintenanceStatus',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getMaintenanceStatus.fulfilled, (state, action) => {
			state.isMaintenanceStatusLoading = false;
			state.isMaintenanceStatusSuccess = true;
			state.itemMaintenanceStatusDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getMaintenanceStatus.pending, state => {
			state.isMaintenanceStatusLoading = true;
			state.isMaintenanceStatusSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getMaintenanceStatus.rejected, (state, action) => {
			state.isMaintenanceStatusLoading = false;
			state.isMaintenanceStatusSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});
		
		builder.addCase(getMaintenanceStatusCode.fulfilled, (state, action) => {
			state.isMaintenanceStatusLoading = false;
			state.isMaintenanceStatusSuccess = true;
			state.itemMaintenanceStatusDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getMaintenanceStatusCode.pending, state => {
			state.isMaintenanceStatusLoading = true;
			state.isMaintenanceStatusSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getMaintenanceStatusCode.rejected, (state, action) => {
			state.isMaintenanceStatusLoading = false;
			state.isMaintenanceStatusSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getMaintenanceStatusList.pending, state => {
			state.isMaintenanceStatusSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getMaintenanceStatusList.fulfilled, (state, action) => {
			state.itemMaintenanceStatusList = action.payload;
			state.maintenanceStatusList = action.payload;
			state.isLoadingList = false;
			state.isMaintenanceStatusSuccess = true;

			let maintenanceStatusListSelect = [];
			action.payload.map(item =>
				maintenanceStatusListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.maintenanceStatusListSelect = maintenanceStatusListSelect;
		});
		builder.addCase(getMaintenanceStatusList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isMaintenanceStatusSuccess = true;
		});
		builder.addCase(addNewMaintenanceStatus.fulfilled, (state, action) => {
			state.itemMaintenanceStatusList.push(action.payload);
			state.maintenanceStatusList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewMaintenanceStatus.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewMaintenanceStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateMaintenanceStatus.fulfilled, (state, action) => {
			state.itemMaintenanceStatusList = state.itemMaintenanceStatusList.map(maintenanceStatus =>
				maintenanceStatus.maintenanceStatusname === action.payload.old_maintenanceStatus
					? { ...maintenanceStatus, ...action.payload.updated_maintenanceStatus }
					: maintenanceStatus
			);
			state.maintenanceStatusList = state.maintenanceStatusList.map(maintenanceStatus =>
				maintenanceStatus._id.toString() === action.payload._id.toString()
					? { ...maintenanceStatus, ...action.payload }
					: maintenanceStatus
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateMaintenanceStatus.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateMaintenanceStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteMaintenanceStatus.fulfilled, (state, action) => {
			state.itemMaintenanceStatusList = current(state.itemMaintenanceStatusList).filter(
				item => item._id !== action.payload._id
			);
			state.maintenanceStatusList = current(state.maintenanceStatusList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteMaintenanceStatus.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteMaintenanceStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = MaintenanceStatusSlice.actions;

export default MaintenanceStatusSlice.reducer;
